import { WebPlugin } from '@capacitor/core';
export class JailbreakRootWeb extends WebPlugin {
    async isJailbrokenOrRooted() {
        return {
            result: false,
        };
    }
}
